// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OPGSD","fixed":"Header_fixed__FTMLi","logo":"Header_logo__04L6z","list":"Header_list__R4BIU","item":"Header_item__WkkSW"};